import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-footer" }
const _hoisted_2 = { class: "w-footer-left" }
const _hoisted_3 = { class: "w-footer-caption" }
const _hoisted_4 = { class: "w-version" }
const _hoisted_5 = {
  class: "w-log",
  "aria-label": "Последние действия"
}

import { computed } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';

const LOG_SIZE = 3;


export default /*@__PURE__*/_defineComponent({
  __name: 'CalendarFooter',
  setup(__props) {

const store = useScheduleStore();

const lastEntries = computed(() => store.schedule.logs.slice(0, LOG_SIZE));

// Время действия — в часовом поясе филиала
const formatTime = (at: string) => new Date(at).toLocaleTimeString('ru-RU', {
  hour: '2-digit',
  minute: '2-digit',
  timeZone: store.currentBranch?.timeZone || 'UTC',
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "Данные сервера", -1)),
        _createElementVNode("span", _hoisted_4, "версия " + _toDisplayString(_unref(store).schedule.revision), 1)
      ]),
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lastEntries.value, (entry, index) => {
          return (_openBlock(), _createElementBlock("li", { key: index }, [
            _createElementVNode("time", null, _toDisplayString(formatTime(entry.at)), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(store).lastName(entry.actorId)) + ": " + _toDisplayString(entry.message), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})